import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';
import { getHeading } from '../../selectors/seo/getHeading';
import { useSelector } from 'react-redux';

export const Heading = () => {
  const heading = useSelector(getHeading);

  return <UIHeading2 as="h1">{heading}</UIHeading2>;
};
